import React, { type ReactNode, type Ref } from 'react';

import Button, { type ButtonProps } from '@atlaskit/button/new';
import type { AnyEntryPoint } from '@atlassian/entry-point-types';

import { ModalTrigger, type ModalTriggerProps } from './modal-trigger';

export type ModalButtonTriggerProps<TEntryPoint> = Omit<
	ModalTriggerProps<TEntryPoint>,
	'children'
> & {
	modalTitle?: ReactNode;
} & Omit<ButtonProps, 'ref' | 'onError'>; // Prevent ref prop collision between ButtonProps and render prop

export function ModalButtonTrigger<TEntryPoint extends AnyEntryPoint>({
	children,
	entryPoint,
	entryPointParams,
	entryPointProps,
	Fallback,
	modalTitle,
	modalProps,
	forwardedRef,
	onError,
	preloadOnFocus,
	...buttonProps
}: ModalButtonTriggerProps<TEntryPoint>): React.JSX.Element {
	return (
		<ModalTrigger
			forwardedRef={forwardedRef}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			entryPointProps={entryPointProps}
			Fallback={Fallback}
			title={modalTitle}
			modalProps={modalProps}
			onError={onError}
			preloadOnFocus={preloadOnFocus}
		>
			{({ ref }) => (
				<Button ref={ref as Ref<HTMLButtonElement>} {...buttonProps}>
					{children}
				</Button>
			)}
		</ModalTrigger>
	);
}
